import React from 'react';
import {cn} from '@/utils/common_functions';

export interface SwitchProps {
  value: boolean;
  onChange: (value: boolean) => void;
  disabled?: boolean;
}


export const Switch: React.FC<SwitchProps> = ({
  value,
  onChange,
  disabled = false,
}) => {
  const handlePress = () => {
    if (!disabled) {
      onChange(!value);
    }
  };

  return (
    <button
      onClick={handlePress}
      disabled={disabled}
      className={cn([
        'rounded-full flex flex-shrink-0 cursor-pointer border-ui_blue bg-[#E6E0E9] border-[1px] disabled:opacity-60 transition-all duration-300 w-7 p-[2px] justify-start',
        value && 'bg-ui_blue justify-end',
        disabled && 'cursor-not-allowed',
      ])}>
      <div className={cn([
        'rounded-full bg-ui_blue size-[10px]',
        value && 'bg-white',
      ])}/>
    </button>
  );
};

